import styled from 'styled-components';

//components
import { Container } from '@/components/Grid';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const Section = styled.section`
  padding: 40px 0;
  border-top: 1px solid ${homeColor.carbon};

  ${screen.md} {
    padding: 60px 0;
  }

  ${screen.lg} {
    padding: 80px 0;
  }

  ${screen.xxlg} {
    padding: 100px 0;
  }
`;

export const SectionWrap = styled(Container)`
  max-width: 100%;
  padding: 0 29px;

  ${screen.sm} {
    max-width: 100%;
  }

  ${screen.md} {
    max-width: 100%;
    padding: 0 47px;
  }

  ${screen.lg} {
    max-width: 100%;
    padding: 0 126px;
  }

  ${screen.xxlg} {
    max-width: 1920px;
    margin: 0 auto;
    padding: 0 280px;
  }
`;

export const Kicker = styled.div`
  font-family: ${getToken('font-family-default')};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: ${(props) => props.color || homeColor.green};
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 9px;
`;

export const KickerDot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: ${(props) => props.color || homeColor.green};
  box-shadow: 0 0 9px ${(props) => props.color || homeColor.green};
`;

export const SectionTitle = styled.h2`
  font-family: ${getToken('font-family-title')};
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1.08;
  font-size: 26px;
  margin: 0 0 16px;
  max-width: 440px;
  color: ${homeColor.white};

  br {
    display: none;
  }

  ${screen.md} {
    font-size: 32px;
    max-width: 545px;
  }

  ${screen.lg} {
    font-size: 40px;
    max-width: 680px;

    br {
      display: block;
    }
  }
`;

export const SectionLede = styled.p`
  font-family: ${getToken('font-family-default')};
  font-size: 17px;
  color: ${homeColor.muted};
  max-width: 625px;
  line-height: 1.6;
  margin: 0;
`;

export const Grad = styled.span`
  background: linear-gradient(45.01deg, #00d7d7 23.29%, #84f11e 88.12%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`;

export const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-family: ${getToken('font-family-default')};
  font-weight: 600;
  font-size: 9px;
  letter-spacing: 0.1em;

  ${screen.md} {
    font-size: 11px;
  }

  a {
    color: ${homeColor.muted2};

    &:hover {
      color: ${homeColor.white};
    }
  }

  span {
    color: rgba(108, 133, 131, 0.5);
  }

  b {
    color: ${homeColor.white};
    font-weight: 600;
  }
`;

export const BreadcrumbLink = styled.a``;
